import { useState, type FormEvent } from "react";
import { Brand } from "../../components/Brand";
import { api } from "../../lib/api";
import { readableError } from "../../lib/errors";

export function RecoveryScreen({ onDone }: { onDone: () => void }) {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    setError("");
    const data = new FormData(event.currentTarget);
    try {
      const result = await api.recover({
        email: String(data.get("email")),
        recoveryCode: String(data.get("recoveryCode")),
        newPassword: String(data.get("newPassword"))
      });
      setMessage(
        `Password updated. Replace your old recovery code with ${result.nextRecoveryCode}`
      );
    } catch (cause) {
      setError(readableError(cause));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="setup-screen">
      <div className="setup-screen__header">
        <Brand />
        <button className="text-button" onClick={onDone}>Back to sign in</button>
      </div>
      <section className="recovery-form">
        <h1>Recover your account</h1>
        <p>Use the recovery code saved during first-time server setup.</p>
        {message ? (
          <>
            <div className="success-message" role="status">{message}</div>
            <button className="button button--primary" onClick={onDone}>
              RETURN TO SIGN IN
            </button>
          </>
        ) : (
          <form onSubmit={submit}>
            <label>
              <span>Email</span>
              <input name="email" type="email" autoComplete="username" required />
            </label>
            <label>
              <span>Recovery code</span>
              <input name="recoveryCode" autoComplete="one-time-code" required />
            </label>
            <label>
              <span>New password</span>
              <input
                name="newPassword"
                type="password"
                minLength={6}
                autoComplete="new-password"
                required
              />
            </label>
            {error && <p className="form-error" role="alert">{error}</p>}
            <button className="button button--primary" disabled={busy}>
              {busy ? "UPDATING…" : "UPDATE PASSWORD"}
            </button>
          </form>
        )}
      </section>
    </main>
  );
}
